import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-deletecompany',
  templateUrl: './deletecompany.component.html',
  styleUrls: ['./deletecompany.component.scss']
})
export class DeletecompanyComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeletecompanyComponent>,
  ) { }

  ngOnInit(): void { }
}
